// extracted by mini-css-extract-plugin
export default {"collapseHeader":"FormCollapseHeader_collapseHeader__xP+vf"};